import React, { useContext } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import CommissioningReportContext from '@totem/components/salesOrders/commissioning/CommissioningReportContext';

const styles = {
  searchContainer: {
    marginBottom: '0.5rem',
  },
  search: {
    width: '240px',
  },
};

const CommissioningReportFilters = () => {
  const { searchText, setSearchText } = useContext(CommissioningReportContext);

  return (
    <div style={styles.searchContainer}>
      <Input
        prefix={<SearchOutlined />}
        placeholder="Search sales order..."
        style={styles.search}
        value={searchText}
        onChange={(evt) => setSearchText(evt.target.value)}
        allowClear
      />
    </div>
  );
};

export default CommissioningReportFilters;
